<template>
  <div class="loading">
    <div class="app-before-loading">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="less" scoped>
.loading{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @-webkit-keyframes rotate_pacman_half_up {
    0% {
      -webkit-transform: rotate(270deg);
      transform: rotate(270deg); }

    50% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg); }

    100% {
      -webkit-transform: rotate(270deg);
      transform: rotate(270deg); } }

  @keyframes rotate_pacman_half_up {
    0% {
      -webkit-transform: rotate(270deg);
      transform: rotate(270deg); }

    50% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg); }

    100% {
      -webkit-transform: rotate(270deg);
      transform: rotate(270deg); } }

  @-webkit-keyframes rotate_pacman_half_down {
    0% {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg); }

    50% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg); }

    100% {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg); } }

  @keyframes rotate_pacman_half_down {
    0% {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg); }

    50% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg); }

    100% {
      -webkit-transform: rotate(90deg);
      transform: rotate(90deg); } }

  @-webkit-keyframes pacman-balls {
    75% {
      opacity: 0.7; }

    100% {
      -webkit-transform: translate(-100px, -6.25px);
      transform: translate(-100px, -6.25px); } }

  @keyframes pacman-balls {
    75% {
      opacity: 0.7; }

    100% {
      -webkit-transform: translate(-100px, -6.25px);
      transform: translate(-100px, -6.25px); } }

  .app-before-loading {
    position: relative;
  }
  .app-before-loading > div:nth-child(2) {
    -webkit-animation: pacman-balls 1s 0s infinite linear;
    animation: pacman-balls 1s 0s infinite linear; }
  .app-before-loading > div:nth-child(3) {
    -webkit-animation: pacman-balls 1s 0.33s infinite linear;
    animation: pacman-balls 1s 0.33s infinite linear; }
  .app-before-loading > div:nth-child(4) {
    -webkit-animation: pacman-balls 1s 0.66s infinite linear;
    animation: pacman-balls 1s 0.66s infinite linear; }
  .app-before-loading > div:nth-child(5) {
    -webkit-animation: pacman-balls 1s 0.99s infinite linear;
    animation: pacman-balls 1s 0.99s infinite linear; }
  .app-before-loading > div:first-of-type {
    width: 0px;
    height: 0px;
    border-right: 25px solid transparent;
    border-top: 25px solid #1682f1;
    border-left: 25px solid #1682f1;
    border-bottom: 25px solid #1682f1;
    border-radius: 25px;
    -webkit-animation: rotate_pacman_half_up 0.5s 0s infinite;
    animation: rotate_pacman_half_up 0.5s 0s infinite; }
  .app-before-loading > div:nth-child(2) {
    width: 0px;
    height: 0px;
    border-right: 25px solid transparent;
    border-top: 25px solid #1682f1;
    border-left: 25px solid #1682f1;
    border-bottom: 25px solid #1682f1;
    border-radius: 25px;
    -webkit-animation: rotate_pacman_half_down 0.5s 0s infinite;
    animation: rotate_pacman_half_down 0.5s 0s infinite;
    margin-top: -50px; }
  .app-before-loading > div:nth-child(3), .app-before-loading > div:nth-child(4), .app-before-loading > div:nth-child(5), .app-before-loading > div:nth-child(6) {
    background-color: #1682f1;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    margin: 2px;
    width: 10px;
    height: 10px;
    position: absolute;
    -webkit-transform: translate(0, -6.25px);
    -ms-transform: translate(0, -6.25px);
    transform: translate(0, -6.25px);
    top: 25px;
    left: 100px;
  }
}
</style>
